import type { Scalar } from '@rtkwlf/querybroker';

class ScalarBuilder {
  // Required by builder
  #value: Scalar['value'];

  #alias?: Scalar['alias'];

  constructor(value: Scalar['value'], alias?: Scalar['alias']) {
    this.#value = value;
    this.#alias = alias;
  }

  alias = (alias: Scalar['alias']): ScalarBuilder => {
    this.#alias = alias;
    return this;
  };

  toJSON = () => {
    return {
      scalar: {
        alias: this.#alias,
        value: this.#value,
      },
    };
  };

  build = (): { scalar: Scalar } => {
    return this.toJSON();
  };
}

const scalar = (...args: ConstructorParameters<typeof ScalarBuilder>) =>
  new ScalarBuilder(...args);

export type { ScalarBuilder };
export { scalar };
